import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { SortContainer} from './SortArrow.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import SortFade_Icon from "@assets/svg/sortfade.svg";
import SortFull_Icon from "@assets/svg/sortfull.svg";

interface IProps { 
  sortActive?:boolean,
  asc?:boolean,
}

export const SortArrow = (props: IProps) => {
  const {client } = useStore();
  
  return (<>
      <SortContainer sort={props?.asc}>
        {props?.sortActive?  <SortFade_Icon />: <SortFull_Icon />}
      </SortContainer>
  </>);
};

export default SortArrow;
